import React from 'react';
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";
import Item from "../../components/list/Item";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="Docs for Developers"
        desc="An Engineer’s Field Guide to Technical Writing"
        image="/images/books/docs-for-developers.jpg"
        pageType="book"
        author="Jared Bhatti, Zachary Sarah Corleissen, Jen Lambourne, David Nunez, Heidi Waterhouse"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/docs-for-developers.jpg"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                Docs for Developers
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Jared Bhatti, Zachary Sarah Corleissen (Contributor), Jen Lambourne (Contributor), David Núñez (Contributor), Heidi Waterhouse (Contributor)
              </strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                This is a great book for all developers who want to improve their technical writing skills. It covers the essentials of how to write documentation.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                This book will change your way to approach documentation. It will help you to understand the importance of writing good documentation and how to write it.
              </p>

              <h2 className="text-jacarta-700 dark:text-white text-lg leading-normal mb-5 mt-12">
                <strong>A book suggested for</strong>
              </h2>
              <Item
                title=""
                description="This is a book for all type of developers."
              />
              <Item
                title=""
                description="For professionals who works for developer experience and needs to write documentation."
              />

            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
